// Список типов элементов в правой панели — порт ref BlockEditor.tsx:1006-1031.
import { useEffect } from 'react'
import { Plus } from 'lucide-react'
import type { DesignElementType } from '@/types/blocks'
import { DESIGN_LIMITS } from '@/features/editor/lib/designElements'
import { DESIGN_ELEMENT_CARDS } from './designElementCards'
import { setHoveredDesignElement } from '@/features/editor/lib/designHoverPreview'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  count: number
  onAdd: (type: DesignElementType) => void
}

export const ElementPalette = ({ count, onAdd }: Props) => {
  const m = useMessages(messages)
  const atLimit = count >= DESIGN_LIMITS.ELEMENTS
  // Панель закрыли, не уведя мышь со строки, — примерка не должна залипнуть на холсте.
  useEffect(() => () => setHoveredDesignElement(null), [])
  return (
    <div className="space-y-1">
      <p className="mb-2 px-1 text-xs font-medium text-muted-foreground">{m.addElement}</p>
      {atLimit ? (
        <p className="mb-2 px-1 text-xs text-warning">{m.elementsLimit(DESIGN_LIMITS.ELEMENTS)}</p>
      ) : null}
      {DESIGN_ELEMENT_CARDS.map(({ type, label, icon: Icon }) => (
        <button
          key={type}
          type="button"
          disabled={atLimit}
          onClick={() => {
            setHoveredDesignElement(null)
            onAdd(type)
          }}
          // Наведение — примерка элемента на экране слева (`designHoverPreview`).
          onMouseEnter={() => setHoveredDesignElement(type)}
          onMouseLeave={() => setHoveredDesignElement(null)}
          onFocus={() => setHoveredDesignElement(type)}
          onBlur={() => setHoveredDesignElement(null)}
          className="group flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left transition-colors hover:bg-foreground/5 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <span className="flex h-8 w-8 items-center justify-center text-muted-foreground transition group-hover:scale-110 group-hover:text-foreground">
            <Icon className="h-5 w-5" />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block text-sm font-medium text-foreground">{label}</span>
          </span>
          {/* «+» как в окне «Добавить блок»: на наведении подрастает и наливается брендом. */}
          <span className="flex size-7 items-center justify-center rounded-lg bg-primary text-primary-foreground opacity-0 transition group-hover:scale-110 group-hover:bg-brand group-hover:text-brand-foreground group-hover:opacity-100">
            <Plus className="size-4" />
          </span>
        </button>
      ))}
    </div>
  )
}
